import { forumCategoryPolicy } from '@/policies';

(function (angular) {
    'use strict';

    angular.module('app')
        .controller('manageForumCategory', manageForumCategory);

    manageForumCategory.$inject = [
        '$rootScope',
        '$uibModalInstance',
        'ForumCategoriesApi',
        'forumCategoryId',
        'UploadsApi',
        'GroupsApi',
        '$scope'

    ];

    function manageForumCategory(
        $rootScope,
        $uibModalInstance,
        ForumCategoriesApi,
        forumCategoryId,
        UploadsApi,
        GroupsApi,
        $scope

    ) {
        var vm = this;

        vm.permissionChecks = {
            canDelete: forumCategoryPolicy.canDelete(),
        };

        vm.category = {};
        vm.createNewCategory = !forumCategoryId;
        vm.isLoading = false;
        vm.thisUser = $rootScope.thisUser;


        vm.close = close;
        vm.deleteCategory = deleteCategory;
        vm.getOneCategory = getOneCategory;
        vm.updateCategory = updateCategory;
        vm.handleImage = handleImage;
        vm.handleImageError = handleImageError;
        getGroups();
  /**
         * Initialises controller values.
         *
         * @returns {Promise<void>}
         */
        async function bootstrap(): Promise<void> {
            if (!vm.createNewCategory) {
            }

            $scope.$on('modal.closing', function (group, reason, closed) {
                if (!closed && !vm.forceClose) {
                    return group.preventDefault();
                }
            });
        }

        /**
         * Retrieves events
         *
         * @return {void}
         */
        function getGroups() {

            GroupsApi.get({
            }, response => {
                vm.groups = response.data;
            });
        }

        vm.imageUploadOptions = {
            resize: true,
            resizeShape: 'rectangle',
            resizeSize: {
                w: 1140,
                h: 400,
            },
            resizeAspectRatio: 2.85,
        };

        vm.image = {
            data: null,
            uploaded: false,
        };

        /**
         * Handles the image chosen by the user
         *
         * @param  {string} file - base64 image
         * @return {void}
         */
        function handleImage(file) {
            vm.image.data = file;
            vm.image.uploaded = false;
        }

        /**
         * Shows file errors
         * @param  {object} imageError - provided as  {image: '[error msg]'}
         * @return {void}
         */
        function handleImageError(imageError) {
            vm.formErrors = angular.merge(vm.formErrors, imageError);
        }

        /**
         * Uploads the banner image if it has been changed.
         *
         * @returns {Promise<Record<string, any>>} The updated category.
         */
        async function saveImage(): Promise<Record<string, any>|void> {
            const promise = new Promise<Record<string, any>|void>(resolve => {
                if (!vm.image.data || vm.image.uploaded) {
                    // No image set, or already uploaded. No need to do anything.
                    return resolve();
                }

                async function handleUploadSuccess(result: { path: string, src: string }): Promise<void> {
                    if (result && result.path) {
                        // update category and save
                        vm.category.img = result.path;

                        return resolve();
                    } else {
                        throw new Error('Invalid response from image upload endpoint.');
                    }
                }

                const handleUploadError = (err: any): void => {
                    throw(err);
                };

                const handleUploadProgress = (progress: number): void => {
                    vm.isLoadingProgress = progress;

                    if (progress === 100) {
                        vm.isLoadingProgress = 0;
                        vm.isLoadingMessage = 'Saving image...';
                    }
                };

                vm.isLoadingMessage = 'Uploading image...';
                UploadsApi
                    .uploadFile(vm.image.data, 'site')
                    .then(handleUploadSuccess, handleUploadError, handleUploadProgress);
            });

            return promise;
        }

        /**
         * Close the modal window.
         *
         * @return {void}
         */
        function close() {
            $uibModalInstance.close();
        }

        /**
         * Delete the forum category.
         *
         * @return {void}
         */
        function deleteCategory() {
            ForumCategoriesApi.delete({ categoryId: forumCategoryId }, function () {
                vm.isLoading = false;
                $uibModalInstance.close();
            }, function () {
                vm.isLoading = false;
            });
        }

        /**
         * Get the forum category.
         *
         * @return {void}
         */
        function getOneCategory() {
            vm.isLoading = true;
            ForumCategoriesApi.get({ categoryId: forumCategoryId }, function (category) {
                vm.category = category.data;
                vm.isLoading = false;
            }, function () {
                vm.isLoading = false;
            });
        }

        /**
         * Save the forum category.
         *
         * @return {void}
         */
        function updateCategory() {
            vm.isLoading = true;
            if (vm.createNewCategory) {
                saveImage().then(
                  function () {
                    ForumCategoriesApi.save(vm.category, async function () {
                     vm.isLoading = false;
                     $uibModalInstance.close();
                    }, function () {
                      vm.isLoading = false;
                    });
                  }
                );
              } else {
                saveImage().then(
                  function () {
                    ForumCategoriesApi.update({ categoryId: forumCategoryId }, vm.category, function () {
                      vm.isLoading = false;
                      $uibModalInstance.close();
                    }, function () {
                      vm.isLoading = false;
                    });
                  }
                );
              }
        }

        if (!vm.createNewCategory) {
            vm.getOneCategory();
        }
        bootstrap();

    }
}(angular));
